module.exports = __webpack_public_path__ + "static/media/lundbeck.9da1359b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/lundbeck.png
// module id = 133
// module chunks = 0